<template>
  <div>
    <div class="scroll-y" @scroll="handlerScroll">
      <div class="relative fb fb-col" :style="{ height: `${scrollHeight}px` }">
        <div>
          <div
            class="fb fb-cross-center fb-main-start hidden relative bg-FFFFFF mt-12"
          >
            <div class="lh-48 p-0-16" @click="handlerToSelectDate">
              <span class="font-28">{{ cacheObject[tabIndex].dateStr }}</span
              ><i class="iconfont c-171A1D font-24">&#xe681;</i>
            </div>
          </div>
        </div>
        <div>
          <div class="p-0-16 pb-16 bg-FFFFFF mb-10" v-if="tabIndex === 2">
            <div class="content-card fb">
              <div
                class="item-flex-1 content-card-item"
                v-for="(item, index) in summaryCard"
                :key="index"
                @click="gotoRecords(item)"
              >
                <div
                  class="card-title font-24 fb fb-main-between fb-cross-center"
                >
                  <div class="card-title-name">{{ item.text }}</div>
                  <span class="iconfont card-title-arrow">&#xe68d;</span>
                </div>
                <div
                  class="card-text c-171A1D ff-ding-condensed-bold font-60"
                  >{{ item.value }}</div
                >
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            class="lh-40 fb fb-cross-center fb-main-around c-171A1D-60 mt-10 mb-10"
            v-if="tabIndex === 1"
          >
            <div
              ref="course"
              class="fb fb-main-start p-0-20"
              @click="handlerShowPop(1)"
              :class="{
                'course-highlight': showPopType === 1,
                active: applicationStatus
              }"
            >
              <div class="font-28 mr-4 dept-box text-ellipsis">{{
                (applicationStatus && applicationStatus.text) || '状态'
              }}</div>
              <i class="iconfont font-24">&#xe681;</i>
            </div>
            <div
              ref="course2"
              class="fb fb-main-start p-0-20"
              @click="handlerShowPop(2)"
              :class="{
                'course-highlight': showPopType === 2,
                active: reasonType
              }"
            >
              <div class="font-28 mr-4 dept-box text-ellipsis">{{
                (reasonType && reasonType.text) || '原因'
              }}</div>
              <i class="iconfont font-24">&#xe681;</i>
            </div>
          </div>
        </div>
        <ul class="p-0-16 pb-80" v-if="list.length">
          <li
            class="bg-FFFFFF bd-radio-8 mb-12 pt-16 hidden"
            v-for="(v, index) in list"
            :key="index"
            @click="gotoDetails(v)"
            :class="{
              'item-disabled': [5, 6, 7, 8, 9].includes(v.applicationStatus)
            }"
          >
            <div
              class="p-0-16 font fb lh-24 fb-main-between fb-cross-center mb-12"
            >
              <div class="item-flex-1 fb font-34 c-171A1D ff-regular">
                {{ v.applicantTeacherName | filterBeyondEllipsis }}的调代课
              </div>
              <div
                class="font-24 substitute-status bd-radio-4"
                :class="{
                  wait: v.applicationStatus === 1,
                  success: [2, 3, 4].includes(v.applicationStatus),
                  end: [5, 6, 7, 8, 9].includes(v.applicationStatus)
                }"
                >{{ SUBSTITUTE_STATUS[v.applicationStatus] }}</div
              >
            </div>
            <div class="mb-8 p-0-16 c-171A1D-60 lh-20 font-28 text-bold-400">
              <span>原因：</span>
              <span>{{ SUBSTITUTE_STATUS_TYPE[v.reasonType] }}</span>
            </div>
            <div
              class="mb-8 p-0-16 c-171A1D-60 lh-20 font-28 text-bold-400"
              v-if="+v.selectionSelectType === 1"
            >
              <span>时间：</span>
              <span>{{ v | filterTimeText }}</span>
            </div>
            <div
              class="mb-8 p-0-16 c-171A1D-60 lh-20 font-28 text-bold-400 fb"
              v-else
            >
              <span class="inline-block vertical-top">节次：</span>
              <span class="inline-block item-flex-1 ellipsis-l2 sections-text">
                {{ v.items | filterSectionsText }}
              </span>
            </div>
            <div
              class="mb-8 p-0-16 c-171A1D-60 lh-20 font-28 text-bold-400"
              v-if="
                v.applicationStatus !== 1 &&
                (v.statistics.adjustCount || v.statistics.substituteCount)
              "
            >
              <span>课程安排：</span>
              <span>
                {{ v | filterArrangeText }}
              </span>
            </div>
            <div
              class="mb-8 p-0-16 c-171A1D-60 lh-20 font-28 text-bold-400"
              v-else
            >
              <span>课时数：</span>
              <span> {{ v.statistics.totalSection }}节</span>
            </div>
            <div class="mb-12 p-0-16 c-171A1D-60 lh-20 font-28 text-bold-400">
              <span>创建时间：</span>
              <span>{{ v | filterTimeFormat }}</span>
            </div>
            <!-- 只有待安排会显示按钮 -->
            <div
              class="buttons font-34 fb fb-main-between"
              v-if="
                v.applicationStatus === 1 &&
                !isSchoolTermEnd &&
                tabIndex === 1 &&
                isAdmin
              "
            >
              <div class="item-flex-1" @click.stop="changeStatus(v)">退回</div>
              <div class="item-flex-1">去安排</div>
            </div>
          </li>
        </ul>
        <div class="relative item-flex-1" v-else>
          <common-no-data class="no-record">
            <div class="no-course no-item"></div>
            <p class="font-28 c-171A1D-40">暂无记录</p>
          </common-no-data>
        </div>
        <!-- 弹层筛选 -->
        <div
          class="pop-con font-34 ff-medium c-171A1D"
          v-show="showPopType"
          v-click-outside="clickOutside"
        >
          <div class="pop-body">
            <div class="course-list">
              <div
                class="course-list-item"
                v-for="(item, index) in showPopType === 1
                  ? SUBSTITUTE_STATUS_DATA
                  : SUBSTITUTE_STATUS_TYPE_DATA"
                :key="index"
                @click="chooseCourseHandler(item)"
                ><i
                  v-if="item.id === activeId"
                  class="iconfont c-006AFE font-44 icon-select"
                  >&#xe725;</i
                ><span class="font-34">{{ item.text }}</span></div
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-date-picker
      v-model="visible"
      ref="picker"
      v-if="showConfirmPicker"
      class="evaluation-date-picker"
      :visibleItemCount="5"
      :label-config="labelConfig"
      :default-index="cacheObject[tabIndex].defaultIndex"
      @confirm="getPickerDate"
      @init-date="initPickerDate"
      :campus-id="campusId"
      :isUseTermIndex="true"
    ></common-date-picker>
    <div
      class="footer fb fb-main-start fb-cross-center"
      ref="footerCommonButton"
    >
      <md-button v-if="isAdmin && isAdminPage" @click="handlerEdit"
        >调代课安排
      </md-button>
      <md-button v-else-if="!isAdminPage" @click="handlerEdit"
        >发起调代课</md-button
      >
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonDatePicker from './commonDatePicker'
import commonNoData from './commonNoData'
import { timeFormat, dateToTime, deepCopy } from '@/utils/comUtils'
import API from '@/api'
import {
  NUM_TEXT,
  SUBSTITUTE_STATUS,
  SUBSTITUTE_STATUS_DATA,
  SUBSTITUTE_STATUS_TYPE,
  SUBSTITUTE_STATUS_TYPE_DATA
} from '@/utils/constUtils'
export default {
  mixins: [mixin],
  data() {
    return {
      SUBSTITUTE_STATUS_TYPE,
      SUBSTITUTE_STATUS,
      SUBSTITUTE_STATUS_DATA,
      SUBSTITUTE_STATUS_TYPE_DATA,
      visible: false,
      showConfirmPicker: false,

      labelConfig: {
        chooseDate: false
      },
      cacheObject: {
        1: {
          defaultIndex: [
            this.$store.getters.semesterList.length === 2
              ? this.$store.getters.semesterSetting.termOrder - 1
              : 0,
            2,
            0
          ],
          dateStr: '',
          endDimDay: this.$store.getters.semesterSetting.termEndDimDay,
          startDimDay: this.$store.getters.semesterSetting.termStartDimDay
        },
        2: {
          defaultIndex: [
            this.$store.getters.semesterList.length === 2
              ? this.$store.getters.semesterSetting.termOrder - 1
              : 0,
            2,
            0
          ],
          dateStr: '',
          endDimDay: this.$store.getters.semesterSetting.termEndDimDay,
          startDimDay: this.$store.getters.semesterSetting.termStartDimDay
        }
      },
      applicationStatus: null,
      reasonType: null,
      pageNum: 1,
      pageSize: 20,
      loadAll: false,
      activeId: '',
      showPopType: null,
      list: [],
      summaryCard: [
        {
          key: 2,
          text: '代课数',
          value: ''
        },
        {
          key: 3,
          text: '被代课数',
          value: ''
        },
        {
          key: 1,
          text: '调课数',
          value: ''
        }
      ],
      substituteWidth: '',
      firstLoad: true,
      unWatch: null,
      isLoadig: false
    }
  },
  props: {
    scrollHeight: {
      type: Number,
      default: 0
    },
    tabIndex: {
      type: Number,
      default: 1
    },
    isAdminPage: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    filterArrangeText(v) {
      let str = []
      if (v.statistics && v.statistics.adjustCount) {
        str.push(`调课${v.statistics.adjustCount}节`)
      }
      if (v.statistics && v.statistics.substituteCount) {
        str.push(`代课${v.statistics.substituteCount}节`)
      }
      return str.join('，')
    },
    filterBeyondEllipsis(text) {
      if (!text) {
        return text
      }
      return text.length < 8 ? text : text.slice(0, 8) + '···'
    },
    filterSectionsText(data) {
      try {
        let str = []
        data.map(item => {
          str.push(
            `${dateToTime(item.sourceSection.dimDay, '.')} 第${
              NUM_TEXT[item.sourceSection.sectionNumber]
            }节`
          )
        })
        return str.join('、')
      } catch (error) {
        return '-'
      }
    },
    filterTimeText(v) {
      try {
        return `${dateToTime(v.startDimDay, '.')} 第${
          NUM_TEXT[v.startSectionNumber]
        }节~${dateToTime(v.endDimDay, '.')} 第${NUM_TEXT[v.endSectionNumber]}节`
      } catch (error) {
        return '-'
      }
    },
    filterTimeFormat(v) {
      try {
        return timeFormat(new Date(v.gmtCreate), 'YYYY.MM.DD hh:mm')
      } catch (error) {
        return v.gmtCreate
      }
    }
  },
  components: {
    commonDatePicker,
    commonNoData
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        function documentHandler(e) {
          if (el.contains(e.target)) {
            return false
          }
          if (binding.expression) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = documentHandler
        document.addEventListener('click', documentHandler)
      },
      unbind(el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        delete el.__vueClickOutside__
      }
    }
  },
  created() {
    if (this.$store.getters.applicationStatus) {
      this.applicationStatus = this.$store.getters.applicationStatus
    }
    if (this.$store.getters.reasonType) {
      this.reasonType = this.$store.getters.reasonType
    }
    if (this.$store.getters.cacheObject) {
      this.cacheObject = this.$store.getters.cacheObject
    }
    this.showConfirmPicker = true

    // 手动watch
    this.unWatch = this.$watch('tabIndex', (newVal, oldVal) => {
      this.showPopType = null
      this.firstLoad = true
      // 重新初始化日期数据
      this.showConfirmPicker = false
      this.$nextTick(() => {
        this.showConfirmPicker = true
      })
    })
  },
  destroyed() {
    this.unWatch && this.unWatch()
  },
  methods: {
    handlerEdit() {
      if (this.isSchoolTermEnd) {
        this.$Toast({
          content: '当前不在学年学期内'
        }).show()
        return
      }
      this.$router.push({
        path: '/substitute/arrange',
        query: {
          type: this.isAdminPage ? 1 : 2
        }
      })
    },
    setStoreCache() {
      // 缓存
      this.$store.commit('activeTabIndex', this.tabIndex)
      this.$store.commit('cacheObject', this.cacheObject)
      this.$store.commit('applicationStatus', this.applicationStatus)
      this.$store.commit('reasonType', this.reasonType)
    },
    // 获取个人汇总统计
    getTeacherStatistics() {
      let startDimDay = this.cacheObject[this.tabIndex].startDimDay
      let endDimDay = this.cacheObject[this.tabIndex].endDimDay
      API.getTeacherStatistics({
        ...this.commonTerm,
        endDimDay,
        startDimDay,
        teacherDingId: this.dingUserId,
        campusId: this.campusId,
        operUserRoleTypes: this.currentRole
      })
        .then(res => {
          this.summaryCard[0].value = res.substituteCount
          this.summaryCard[1].value = res.beSubstitutedCount
          this.summaryCard[2].value = res.adjustCount
          this.$forceUpdate()
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取列表
    getList(val) {
      if (this.isLoadig) {
        return false
      }
      this.isLoadig = true
      if (val === true) {
        this.pageNum = 1
        this.list = []
        this.loadAll = false
      }
      let startDimDay = this.cacheObject[this.tabIndex].startDimDay
      let endDimDay = this.cacheObject[this.tabIndex].endDimDay

      let applicationStatusList = []
      if (this.applicationStatus && this.applicationStatus.id) {
        applicationStatusList.push(this.applicationStatus.id)
        if (+this.applicationStatus.id === 6) {
          applicationStatusList.push(7)
        }
      }
      applicationStatusList = applicationStatusList.length
        ? applicationStatusList
        : null

      const params = {
        ...this.commonTerm,
        campusId: this.campusId,
        endDimDay,
        startDimDay,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        operUserRoleTypes: this.currentRole,
        applicationStatusList,
        reasonType: (this.reasonType || {}).id || null,
        schoolTermOrder: this.cacheObject[this.tabIndex].schoolTermOrder
      }
      if (this.tabIndex === 2) {
        params.teacherDingId = this.dingUserId
      }
      const defaultIndex = this.cacheObject[this.tabIndex].defaultIndex
      if (defaultIndex && defaultIndex[1] === 2) {
        delete params.startDimDay
        delete params.endDimDay
      }

      let termStartDimDay = ''
      let termEndDimDay = ''
      this.$store.getters.semesterList.map(v => {
        if (v.schoolTermOrder === params.schoolTermOrder) {
          termStartDimDay = v.schoolTermStartDimDay
          termEndDimDay = v.schoolTermEndDimDay
        }
      })
      // 月份查询的时候 限制学期  优先取学期内的日期
      if (defaultIndex[1] === 1) {
        params.startDimDay = Math.max(termStartDimDay, params.startDimDay)
        params.endDimDay = Math.min(termEndDimDay, params.endDimDay)
      }
      return new Promise((resolve, reject) => {
        API.substituteListPage(params)
          .then(res => {
            let _res = res || []
            if (!_res.length) {
              this.loadAll = true
              return
            }
            _res.map(v => {
              if (v.sourceSection && v.targetSection) {
                let __sourceSection = deepCopy(v.sourceSection)
                let __targetSection = deepCopy(v.targetSection)
                if (v.targetSection.teacherDingId === this.dingUserId) {
                  v.sourceSection = __targetSection
                  v.targetSection = __sourceSection
                }
              }
            })
            if (this.pageNum === 1) {
              this.list = _res
            } else {
              this.list = this.list.concat(_res)
            }
            this.pageNum++
            resolve(res)
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
          .finally(() => {
            this.isLoadig = false
          })
      })
    },
    gotoRecords(params) {
      this.$router.push({
        path: '/substitute/record',
        query: {
          type: params.key
        }
      })
    },
    changeStatus({ scheduleSubstituteId }) {
      const that = this
      this.$Dialog({
        type: 'confirm',
        title: '系统提示',
        content: `<div class="text-left">确认将调代课申请退回？</div>`,
        cancelBtn: {
          color: '#006afe',
          text: '取消'
        },
        confirmBtn: {
          color: '#006afe',
          text: '确认'
        },
        onConfirm() {
          API.substituteUpdateStatus({
            ...that.commonParams,
            applicationStatus: 8,
            scheduleSubstituteId,
            operUserRoleTypes: that.currentRole
          })
            .then(res => {
              if (res && res.result && res.result !== '0') {
                that
                  .$Toast({
                    type: 'fail',
                    content: res.message
                  })
                  .show()
                return
              }
              that
                .$Toast({
                  type: 'success',
                  content: '退回成功'
                })
                .show()
              that.getList(true)
            })
            .catch(err => {
              console.log('unhandledrejection', err)
            })
        }
      }).show()
    },
    // 分页加载数据
    handlerScroll(e) {
      if (this.loadAll) {
        return
      }
      this.showPopType = null
      let _el = e.currentTarget
      if (
        (this.list || []).length &&
        _el.scrollTop + _el.clientHeight >= _el.scrollHeight - 20
      ) {
        this.loadAll = (this.list || []).length < this.pageSize
        this.getList(false)
      }
    },
    gotoDetails({ scheduleSubstituteId }) {
      this.setStoreCache()
      this.mixinRouter('/substitute/detail', {
        scheduleSubstituteId,
        type: this.tabIndex
      })
    },
    // 初始化日期
    initPickerDate({ activeIndex, dateStr, activeValue }) {
      let cacheObject = this.$store.getters.cacheObject
      // 首次优先使用 store 缓存
      if (this.firstLoad && cacheObject && cacheObject[this.tabIndex]) {
        this.firstLoad = false
        this.cacheObject[this.tabIndex] = cacheObject[this.tabIndex]
        if (this.tabIndex === 2) {
          this.getTeacherStatistics()
        }
        this.getList(true)
        return
      } else if (this.firstLoad) {
        this.firstLoad = false
        this.cacheObject[this.tabIndex] = null
        this.cacheObject[this.tabIndex] = {
          defaultIndex: activeIndex,
          dateStr,
          startDimDay: activeValue && activeValue.startDimDay,
          endDimDay: activeValue && activeValue.endDimDay,
          schoolTermOrder:
            this.$store.getters.semesterList[activeIndex[0]].schoolTermOrder
        }
        this.cacheObject[this.tabIndex === 1 ? 2 : 1] = {
          defaultIndex: activeIndex,
          dateStr,
          startDimDay: activeValue && activeValue.startDimDay,
          endDimDay: activeValue && activeValue.endDimDay,
          schoolTermOrder:
            this.$store.getters.semesterList[activeIndex[0]].schoolTermOrder
        }
      }

      this.handlerPickerData(
        { activeIndex, dateStr, activeValue },
        'initPickerDate'
      )
    },
    // 修改日期
    getPickerDate({ activeIndex, dateStr, activeValue }) {
      this.handlerPickerData(
        { activeIndex, dateStr, activeValue },
        'getPickerDate'
      )
    },
    // 处理日期
    handlerPickerData({ activeIndex, dateStr, activeValue }) {
      this.cacheObject[this.tabIndex] = null
      this.cacheObject[this.tabIndex] = {
        defaultIndex: activeIndex,
        dateStr,
        startDimDay: activeValue && activeValue.startDimDay,
        endDimDay: activeValue && activeValue.endDimDay,
        schoolTermOrder:
          this.$store.getters.semesterList[activeIndex[0]].schoolTermOrder
      }
      this.setStoreCache()
      this.$nextTick(() => {
        if (this.tabIndex === 2) {
          this.getTeacherStatistics()
        }
        this.getList(true)
      })
    },
    handlerToSelectDate() {
      this.visible = true
      this.showPopType = null
    },
    handlerShowPop(type) {
      this.showPopType = this.showPopType === type ? null : type
    },
    chooseCourseHandler(params) {
      if (this.showPopType === 1) {
        this.applicationStatus = params
      } else {
        this.reasonType = params
      }
      this.showPopType = null
      this.setStoreCache()
      this.getList(true)
    },
    clickOutside(e) {
      if (
        (this.$refs.course && this.$refs.course.contains(e.target)) ||
        (this.$refs.course2 && this.$refs.course2.contains(e.target))
      ) {
        return false
      }
      this.showPopType = null
    }
  }
}
</script>

<style lang="scss" scoped>
.content-card {
  padding-top: 30px;
  position: relative;
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    height: 21px;
    font-size: 14px;
    content: '个人汇总';
    color: #171a1d;
    font-weight: 600;
  }
  &-item {
    background: #f2f2f6;
    margin-right: 12px;
    padding: 8px 12px 6px 12px;
    border-radius: 4px;
    &:last-child {
      margin-right: 0;
      .card-title-name::before {
        background: #ff9200;
      }
    }
    &:first-child {
      .card-title-name::before {
        background: #8b7cff;
      }
    }
    .card-title {
      margin-bottom: 12px;
      &-name {
        color: rgba(#171a1d, 0.6);
        position: relative;
        padding-left: 8px;
        &::before {
          position: absolute;
          content: ' ';
          width: 4px;
          height: 8px;
          opacity: 1;
          background: #006afe;
          border-radius: 2px;
          top: 5px;
          left: 0;
        }
      }
      &-arrow {
        color: #bfc2c9;
      }
    }
  }
}
.pop-con {
  position: absolute;
  top: 110px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(23, 26, 29, 0.28);
  z-index: 99;
  overflow: hidden;
  height: 100vh;
  .pop-body {
    padding: 0 16px;
    background: #fff;
    max-height: 336px;
    overflow: auto;
    .course-list-item {
      height: 56px;
      line-height: 56px;
      padding-left: 48px;
      position: relative;
      &:first-child {
        &::before {
          display: none;
        }
      }
      &::before {
        position: absolute;
        height: 1px;
        width: 100%;
        left: 0;
        top: 0;
        background-color: rgba(25, 31, 37, 0.12);
        content: ' ';
      }
      .icon-select {
        position: absolute;
        left: 16px;
      }
    }
  }
}
.buttons {
  border-top: 1px solid rgba(25, 31, 37, 0.08);
  color: #006afe;
  font-weight: 400;
  text-align: center;
  div {
    height: 100%;
    padding: 10px 0;
    cursor: pointer;
  }
  div:first-child {
    border-right: solid 1px rgba(25, 31, 37, 0.08);
  }
}
.substitute-people {
  width: calc(100% - 136px - 48px);
}
.substitute-status {
  background: rgba(255, 146, 0, 0.12);
  padding: 2px 10px;
  text-align: center;
  line-height: normal;
  color: #ff9200;
  // 进行中
  &.wait {
    background: rgba(255, 146, 0, 0.12);
    color: #ff9200;
  }
  // 已安排
  &.success {
    background: rgba(0, 176, 66, 0.12);
    color: #00b042;
  }
  // 已结束
  &.end {
    background: rgba(0, 0, 0, 0.08);
    color: rgba(23, 26, 29, 0.4);
  }
}
.no-record {
  .no-course {
    width: 180px;
    height: 180px;
    &.no-item {
      background: url(~@/assets/images/no-data.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
}
.sections-text {
  max-height: 3em;
}
.c-FF5219 {
  color: #ff5219;
}
.active {
  color: #006afe;
}
.course-highlight {
  background: #fff;
  border-radius: 8px 8px 0 0;
  div {
    color: #006afe;
  }
  i {
    color: #006afe;
    transform: rotate(180deg);
  }
}
.evaluation-date-picker {
  :deep(.md-popup .md-popup-content) {
    background: #fff;
    .combo-header {
      display: none;
    }
  }
}
.record-wrap {
  height: 40vh;
}

.ellipsis-pro {
  position: relative;
  overflow: hidden;
  max-height: 3em;
  width: 100%;
  line-height: 1.5;
  outline: 1px solid #ff9900;
}
.ellipsis-pro::before {
  content: '...';
  position: absolute;
  z-index: 1;
  bottom: 0;
  right: 0;
  width: 1.6em;
  padding-left: 3px;
  box-sizing: border-box;
  background-color: white;
}
.ellipsis-pro::after {
  content: '';
  display: inline-block;
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: white;
}
</style>
